import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('position/index', {params});
    },
    getPosition(params) {
        return Service().get('position/get-position', {params});
    },
    show(id) {
        return Service().get('position/show/'+id);
    },
    create(params) {
        return Service().post('position/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('position/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('position/delete/'+id);
    },
}